/*
 * @Descripttion:
 * @version:
 * @Author: wupeng
 * @Date: 2019-07-31 15:03:32
 * @LastEditors: zc
 * @LastEditTime: 2021-02-03 12:00:51
 */
import HeaderPaddingMain from '@/views/layout/HeaderPaddingMain.vue';
var router = [{
  path: '/addStudent',
  component: HeaderPaddingMain,
  name: 'addStudent',
  meta: {
    title: '新增学生',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/student/AddStudent.vue');
    }
  }]
}, {
  path: '/studentImport',
  component: HeaderPaddingMain,
  name: 'studentImport',
  meta: {
    title: '学生导入',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/student/StudentImport.vue');
    }
  }]
}, {
  path: '/studentIdCardImport',
  component: HeaderPaddingMain,
  name: 'studentImport',
  meta: {
    title: '学生身份信息导入',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/student/StudentIdCardImport.vue');
    }
  }]
}, {
  path: '/changeClass',
  component: HeaderPaddingMain,
  name: 'changeClass',
  meta: {
    title: '学生转班',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/student/ChangeClass.vue');
    }
  }]
}, {
  path: '/batchChangeClass',
  component: HeaderPaddingMain,
  name: 'batchChangeClass',
  meta: {
    title: '批量转班',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/student/batchChangeClass.vue');
    }
  }]
}, {
  path: '/schChangeSchool',
  // 校级 学生转校
  component: HeaderPaddingMain,
  name: 'schChangeSchool',
  meta: {
    title: '学生转校',
    noCache: true
  },
  children: [{
    path: '',
    component: function component() {
      return import('@/views/student/changeSchool/ChangeSchoolIndex.vue');
    }
  }]
}];
export default router;